import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DetailPageState({ children, compact = false }) {
  return (
    <div className="detail-page-shell">
      <div className={`detail-page-container ${compact ? 'max-w-4xl' : 'max-w-5xl'} text-white/60`}>
        {children}
      </div>
    </div>
  );
}

export function DetailPageLayout({ backTo, backLabel, compact = false, children }) {
  return (
    <div className="detail-page-shell">
      <div className={`detail-page-container ${compact ? 'max-w-4xl' : 'max-w-5xl'} space-y-10`}>
        <Link to={backTo} className="detail-page-backlink">
          <ArrowLeft className="w-4 h-4" />
          <span>{backLabel}</span>
        </Link>
        {children}
      </div>
    </div>
  );
}
